export const LOAD_MODEL = "LOAD_MODEL";
export const RESET_MODEL = "RESET_MODEL";
export const UPDATE_FILTER = "UPDATE_FILTER";
export const UPDATE_STATS = "UPDATE_STATS";
export const COLAPSE_DASH = "COLAPSE_DASH";
//table  constans
export const UPDATE_TABLE = "UPDATE_TABLE";
export const RESET_TABLE = "RESET_TABLE";
export const RESIZE_TABLE = "RESIZE_TABLE";
export const GET_TABS = "GET_TABS";
export const SWITCH_TAB = "SWITCH_TAB";
export const SET_SELECTION_ELEMENTS = "SET_SELECTION_ELEMENTS";
export const CHANGE_CHECKBOX = "CHANGE_CHECKBOX";
export const CHANGE_COLUMN_CHECKBOX = "CHANGE_COLUMN_CHECKBOX";

// user constans
export const DELETE_USER = "DELETE_USER";
export const USER_INFO = "USER_INFO";
export const SIGN_OUT = "SIGN_OUT";
export const STATUS = "STATUS";

// viewer & filters
export const TEMPLATE = "TEMPLATE";
export const CATEGORY = "CATEGORY";
export const SECOND = "SECOND";
export const RESET = "RESET";
export const CLEAR_SETTING_VIEWER = "CLEAR_SETTING_VIEWER";
export const SET_CATEGORY = "SET_CATEGORY";

// statistics filter
export const CLEAR_FILTER = "CLEAR_FILTER";
export const ADD_FILTER = "ADD_FILTER";
export const SET_INITIAL_SELECTORS_VALUES = "SET_INITIAL_SELECTORS_VALUES";
export const REMOVE_TAG = "REMOVE_TAG";
export const RECALCULATION_FILTER = "RECALCULATION_FILTER";

// statistics table
export const FILTER_TABLE = "FILTER_TABLE";
export const SET_INIT_TABLE_CONTENT = "SET_INIT_TABLE_CONTENT";

//currentProject
export const SET_CURRENT_PROJECT = "SET_CURRENT_PROJECT"